import { AbstractControl, ValidatorFn } from '@angular/forms';

import { validString } from 'src/app/shared/utilities/types.utils';

export const EMAIL_REGEX =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

export function emailValidator(): ValidatorFn {
	return (control: AbstractControl): { email: boolean } | null => {
		if (!validString(control.value)) {
			return null;
		}

		if (EMAIL_REGEX.test(control.value)) {
			return null;
		}

		return {
			email: true,
		};
	};
}
